module.exports = __webpack_public_path__ + "static/media/opdl.b92714d8.png";